/**
 * @desc 销售订单待报关报表导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.customsDeclarationApplyDetails.exportForTwo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationApplyDetails/exportForTwo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
